module.exports = __webpack_public_path__ + "static/img/testSuccess.f7666f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testSuccess.png
// module id = 13+j
// module chunks = 2